import riseOfSkywalker from "../Components/Films/img/the-rise-of-skywalker.webp";
import solo from "../Components/Films/img/solo.webp";
import lastJedi from "../Components/Films/img/the-last-jedi.webp";
import rogueOne from "../Components/Films/img/rogue-one.webp";
import forceAwakens from "../Components/Films/img/the-force-awakens.webp";
import revegneOfSith from "../Components/Films/img/revenge-of-the-sith.webp";
import attackOfClones from "../Components/Films/img/attack-of-the-clones.webp";
import phantom from "../Components/Films/img/the-phantom.webp";
import returnOfJedi from "../Components/Films/img/return-of-the-jedi.webp";
import empireStrikesBack from "../Components/Films/img/the-empire-strikes.webp";
import newHope from "../Components/Films/img/a-new-hope.webp";

export const dataFilms = [
   {
      id: 1,
      image: riseOfSkywalker,
      film: "Star Wars: The Rise of Skywalker (Episode IX)",
      year: "2019",
      link: "https://www.starwars.com/films/star-wars-episode-ix-the-rise-of-skywalker",
   },

   {
      id: 2,
      image: solo,
      film: "Solo: A Star Wars Story",
      year: "2018",
      link: "https://www.starwars.com/films/solo",
   },

   {
      id: 3,
      image: lastJedi,
      film: "Star Wars: The Last Jedi (Episode VIII)",
      year: "2017",
      link: "https://www.starwars.com/films/star-wars-episode-viii-the-last-jedi",
   },

   {
      id: 4,
      image: rogueOne,
      film: "Rogue One: A Star Wars Story",
      year: "2016",
      link: "https://www.starwars.com/films/rogue-one",
   },

   {
      id: 5,
      image: forceAwakens,
      film: "Star Wars: The Force Awakens (Episode VII)",
      year: "2015",
      link: "https://www.starwars.com/films/star-wars-episode-vii-the-force-awakens",
   },

   {
      id: 6,
      image: revegneOfSith,
      film: "Star Wars: Revenge of the Sith (Episode III)",
      year: "2005",
      link: "https://www.starwars.com/films/star-wars-episode-iii-revenge-of-the-sith",
   },

   {
      id: 7,
      image: attackOfClones,
      film: "Star Wars: Attack of the Clones (Episode II)",
      year: "2002",
      link: "https://www.starwars.com/films/star-wars-episode-ii-attack-of-the-clones",
   },

   {
      id: 8,
      image: phantom,
      film: "Star Wars: The Phantom Menace (Episode I)",
      year: "1999",
      link: "https://www.starwars.com/films/star-wars-episode-i-the-phantom-menace",
   },

   {
      id: 9,
      image: returnOfJedi,
      film: "Star Wars: Return of the Jedi (Episode VI)",
      year: "1983",
      link: "https://www.starwars.com/films/star-wars-episode-vi-return-of-the-jedi",
   },

   {
      id: 10,
      image: empireStrikesBack,
      film: "Star Wars: The Empire Strikes Back (Episode V)",
      year: "1980",
      link: "https://www.starwars.com/films/star-wars-episode-v-the-empire-strikes-back",
   },

   {
      id: 11,
      image: newHope,
      film: "Star Wars: A New Hope (Episode IV)",
      year: "1977",
      link: "https://www.starwars.com/films/star-wars-episode-iv-a-new-hope",
   },
];
